import { render, staticRenderFns } from "./CapitalChanges.vue?vue&type=template&id=0d556d35&"
import script from "./CapitalChanges.vue?vue&type=script&lang=js&"
export * from "./CapitalChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports